import { Injectable } from '@angular/core';
import { Router} from "@angular/router";
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import getMAC, { isMAC } from 'getmac'
import { environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  //authorizationData:any='';
  private BASE_URL: string = environment.API_URL;
  private BASE_URL_PHP: string = environment.PHP_API;
  private errorData: any = {}; 
  usersLoginDatasToken = JSON.parse(localStorage.getItem('userLoginData') || '[]');
  usersLoginData:any = JSON.parse(localStorage.getItem('userLoginPass') || '[]');
  username: string = this.usersLoginData.email; password: string = this.usersLoginData.pass;
  authorizationData :any= 'Basic ' + btoa(this.username + ':' + this.password);
  httpOptions2 = {
    headers: new HttpHeaders({ 'Authorization': this.authorizationData,'loginToken':this.usersLoginDatasToken.token})
  };
  constructor(private http: HttpClient, private router: Router) {
  }
  
	httpOptions = {
		headers: new HttpHeaders({
			"Content-Type": "application/json",
		}),
	};
  httpOptions1 = {
    headers: new HttpHeaders({ 'Authorization': this.authorizationData})
  };
 
   /**********Create Module Assessemnt Detail************/
  //  assignCourse(status:number): Observable<any>{
  //   return this.http.post(this.BASE_URL+'user/assigned/courses',{ "status" : status},this.httpOptions1);
  //  }
    authGet(){
      return this.httpOptions2;
    }
    authSet(logindata: any,username:any,password:any){
      let authorization = 'Basic ' + btoa(username + ':' + password);
      this.httpOptions2 = {
        headers: new HttpHeaders({ 'Authorization': authorization,'loginToken':logindata.token})
      };
    }
    /**********Create Module Assessemnt Detail************/
    assignCourses(status:number,user_id:number): Observable<any>{
      return this.http.post(this.BASE_URL+'user/assigned/courses',{ "status" : status,"user_id":user_id},this.httpOptions2);
     }
   /**********Create Module Assessemnt Detail************/
   assignLastViewCourse(userId:number): Observable<any>{
    return this.http.post(this.BASE_URL+'last/viewed-course',{ "user_id" : userId},this.httpOptions2);
   }
   assignAssessment(status:number,user_id:number): Observable<any>{
    return this.http.post(this.BASE_URL+'customer/assessmnt/list',{ "status" : status,"user_id":user_id},this.httpOptions2);
   }
 /**********Create Module Assessemnt Detail************/
 assignLastViewAssmnt(userId:number): Observable<any>{
  return this.http.post(this.BASE_URL+'last/viewed-course',{ "user_id" : userId},this.httpOptions2);
 }
   /**********Create Module Assessemnt Detail************/
   assignCourseDetails(userId:number,courseId:any): Observable<any>{
    return this.http.post(this.BASE_URL+'user/assgined-course-details',{ "user_id" : userId,"course_id":courseId},this.httpOptions2);
   }
   /**********view capsule Detail************/
   viewerSubModuleDetail(userId:number,module_id:any,submodule_id:any): Observable<any>{
    return this.http.post(this.BASE_URL+'user/submodule/content-capsule-details',{ "user_id" : userId,"module_id":module_id,"submodule_id":submodule_id},this.httpOptions2);
   }
   /**********view assessment Detail************/
   assessmentData(assId:number,user_id:any,course_id:any): Observable<any>{
    return this.http.post(this.BASE_URL+'assessment/details',{ "assessment_id" : assId,"user_id":user_id,"course_id":course_id},this.httpOptions2);
   }
   /***********get previous question data ******/
   assessmentPreData(assId:number,user_id:any,course_id:any): Observable<any>{
    return this.http.post(this.BASE_URL+'assessment/previous/details',{ "assessment_id" : assId,"user_id":user_id,"course_id":course_id},this.httpOptions2);
   }
   /**********start sub module view************/
   subModuleStartView(user_id:number,course_id:any,module_id:any,submodule_id:any): Observable<any>{
    return this.http.post(this.BASE_URL+'user/submodule/start-date',{ "user_id" : user_id,"course_id":course_id,"module_id":module_id,"submodule_id":submodule_id},this.httpOptions2);
   }
  //  /**********End sub module view************/
  //  subModuleEndView(user_id:number,course_id:any,module_id:any,submodule_id:any,total_time_spent:any): Observable<any>{
  //   return this.http.post(this.BASE_URL+'user/submodule/end-date',{ "user_id" : user_id,"course_id":course_id,"module_id":module_id,"submodule_id":submodule_id,"total_time_spent":total_time_spent},this.httpOptions1);
  //  }
   /**********End sub module view************/
   subModuleEndView(user_id:number,course_id:any,module_id:any,submodule_id:any,total_time_spent:any): Observable<any>{
    // return this.http.post(this.BASE_URL_PHP+'rail.php',{ "user_id" : user_id,"course_id":course_id,"module_id":module_id,"submodule_id":submodule_id,"total_time_spent":total_time_spent},this.httpOptions1);
    return this.http.post(this.BASE_URL+'update/course/record',{ "user_id" : user_id,"course_id":course_id,"module_id":module_id,"submodule_id":submodule_id,"total_time_spent":total_time_spent},this.httpOptions2);
   }
   /****module progress based on comppleted submodule sprint */
   moduleProgress(user_id:number,course_id:any,modId:any,submodule_id:any){
    //  return this.http.post(this.BASE_URL_PHP+'module-prog.php',{ "user_id" : user_id,"course_id":course_id,"modId":modId,"submodule_id":submodule_id},this.httpOptions1);
     return this.http.post(this.BASE_URL+'erailBackendProd/module',{ "user_id" : user_id,"course_id":course_id,"modId":modId,"submodule_id":submodule_id},this.httpOptions2);

   }
   /**********End sub module view************/
   subModuleTimeUpdate(user_id:number,course_id:any,module_id:any,submodule_id:any,total_time_spent:any): Observable<any>{
    return this.http.post(this.BASE_URL+'submoduel/updatetime',{ "user_id" : user_id,"course_id":course_id,"module_id":module_id,"submodule_id":submodule_id,"running_time":total_time_spent},this.httpOptions2);
   }
   /**********End sub module view************/
   subModuleIndex(user_id:number,course_id:any,module_id:any,index:any,submodule_id:any): Observable<any>{
    return this.http.post(this.BASE_URL+'user/submodule/index',{ "user_id" : user_id,"submodule_id":submodule_id,"course_id":course_id,"module_id":module_id,"index":index},this.httpOptions2);
   }
    /**********End sub module view************/
    getCourseData(course_id:any): Observable<any>{
      return this.http.post(this.BASE_URL+'view-course-detail',{ "course_id":course_id},this.httpOptions2);
     }
   /**********Assessment question submit************/
   assessmentSubmit(user_id:number,course_id:any,module_id:any,submodule_id:any,assessment_id:any,question_num:any,question_id:any,response_text:any,response_id:any,matchData:any): Observable<any>{
    return this.http.post(this.BASE_URL+'user/assessment',{ "user_id" : user_id,"course_id":course_id,"module_id":module_id,"submodule_id":submodule_id,"assessment_id" : assessment_id,
    "question_num" : question_num,"question_id" : question_id,"response_text": response_text,"response_id" :response_id,"matchData":matchData},this.httpOptions2);
   }

   assessmentSeprateSubmit(user_id:number,course_id:any,module_id:any,submodule_id:any,assessment_id:any,question_num:any,question_id:any,response_text:any,response_id:any,matchData:any): Observable<any>{
    return this.http.post(this.BASE_URL+'user/seprate/assessment',{ "user_id" : user_id,"course_id":course_id,"module_id":module_id,"submodule_id":submodule_id,"assessment_id" : assessment_id,
    "question_num" : question_num,"question_id" : question_id,"response_text": response_text,"response_id" :response_id,"matchData":matchData},this.httpOptions2);
   }

    // /**********Assessment question  Evaluation submit************/
    // assessmentsEvaluationSubmit(user_id:number,course_id:any,module_id:any,submodule_id:any,assessment_id:any,question_num:any,question_id:any,response_text:any,response_id:any,total_time_spent:any,total_question:any,assessmentAttemt:any,assessment_type:any): Observable<any>{
    //   return this.http.post(this.BASE_URL+'user/evaluation-assessment',{ "user_id" : user_id,"course_id":course_id,"module_id":module_id,"submodule_id":submodule_id,"assessment_id" : assessment_id,
    //   "question_num" : question_num,"question_id" : question_id,"response_text": response_text,"response_id" :response_id, "total_time_spent" : total_time_spent,"total_question" : total_question,"attempt_num":assessmentAttemt,"assessment_type":assessment_type},this.httpOptions1);
    //  }
    /**********Assessment question  Evaluation submit************/
    assessmentsEvaluationSubmit(user_id:number,course_id:any,module_id:any,submodule_id:any,assessment_id:any,question_num:any,question_id:any,response_text:any,response_id:any,total_time_spent:any,total_question:any,assessmentAttemt:any,assessment_type:any,matchData:any): Observable<any>{
    // return this.http.post(this.BASE_URL_PHP+'evaluation.php',{ "user_id" : user_id,"course_id":course_id,"module_id":module_id,"submodule_id":submodule_id,"assessment_id" : assessment_id,
     // "question_num" : question_num,"question_id" : question_id,"response_text": response_text,"response_id" :response_id, "total_time_spent" : total_time_spent,"total_question" : total_question,"attempt_num":assessmentAttemt,"assessment_type":assessment_type},this.httpOptions1);
     return this.http.post(this.BASE_URL+'assesment/evaluation/result',{ "user_id" : user_id,"course_id":course_id,"module_id":module_id,"submodule_id":submodule_id,"assessment_id" : assessment_id,
      "question_num" : question_num,"question_id" : question_id,"response_text": response_text,"response_id" :response_id, "total_time_spent" : total_time_spent,"total_question" : total_question,"attempt_num":assessmentAttemt,"assessment_type":assessment_type,"matchData":matchData},this.httpOptions2);
     //return this.http.post(this.BASE_URL+'user/evaluation-assessment',{ "user_id" : user_id,"course_id":course_id,"module_id":module_id,"submodule_id":submodule_id,"assessment_id" : assessment_id,
     // "question_num" : question_num,"question_id" : question_id,"response_text": response_text,"response_id" :response_id, "total_time_spent" : total_time_spent,"total_question" : total_question,"attempt_num":assessmentAttemt,"assessment_type":assessment_type},this.httpOptions1);
     }
    /**********Assessment question  Evaluation submit************/
    modAssessmentsEvaluationSubmit(user_id:number,course_id:any,module_id:any,submodule_id:any,assessment_id:any,question_num:any,question_id:any,response_text:any,response_id:any,total_time_spent:any,total_question:any,assessmentAttemt:any,assessment_type:any): Observable<any>{
      return this.http.post(this.BASE_URL+'user/module-assessment/evaluation',{ "user_id" : user_id,"course_id":course_id,"module_id":module_id,"submodule_id":submodule_id,"assessment_id" : assessment_id,
      "question_num" : question_num,"question_id" : question_id,"response_text": response_text,"response_id" :response_id, "total_time_spent" : total_time_spent,"total_question" : total_question,"attempt_num":assessmentAttemt,"assessment_type":assessment_type},this.httpOptions2);
    }
     /******start assessement *********/
     startAssessment(user_id:number,course_id:any,assessment_id:any): Observable<any>{
      return this.http.post(this.BASE_URL+'user/assessment/start',{ "user_id" : user_id,"assessment_id":assessment_id,"course_id":course_id},this.httpOptions2);
     }
     /******get assessement taken time *********/
     getAssessmentTime(user_id:number,course_id:any,assessment_id:any): Observable<any>{
      return this.http.post(this.BASE_URL+'user/get-assessment-start-time',{ "user_id" : user_id,"assessment_id":assessment_id,"course_id":course_id},this.httpOptions2);
     }
     assessmentUpdateTime(user_id:number,assessment_id:any): Observable<any>{
      return this.http.post(this.BASE_URL+'user/assessment/updatetime',{ "user_id" : user_id,"assessment_id":assessment_id},this.httpOptions2);
     }
    /******get module detail *********/
    getModuleDetail(module_id:number): Observable<any>{
      return this.http.post(this.BASE_URL+'module/data',{ "module_id" : module_id},this.httpOptions2);
      }
    /******get module sub module detail *********/
    getModulSubDetail(module_id:any,submodule_id:any,course_id:any): Observable<any>{
      return this.http.post(this.BASE_URL+'get/module-submodule/name',{ "module_id" : module_id,"submodule_id":submodule_id,"course_id":course_id},this.httpOptions2);
      }
    /******get module and course level PDF detail *********/
    getPdf(user_id:any,course_id:any,module_id:any): Observable<any>{
      return this.http.post(this.BASE_URL+'download/certificate',{"user_id":user_id,"course_id":course_id,"module_id" : module_id},this.httpOptions2);
      }
   /**********End sub module view************/
   contact(formData:any): Observable<any>{
    return this.http.post(this.BASE_URL+'contact/us',formData);
   }
  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
  
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
  
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }
  
    // return an observable with a user-facing error message
    this.errorData = {
      errorTitle: 'Oops! Request for document failed',
      errorDesc: 'Something bad happened. Please try again later.'
    };
    return throwError(this.errorData);
  }
  // Contact to Administrator
  contactAdministrator(user_id:number,course_id:any,assessment_id:any, request_status:any): Observable<any>{
    return this.http.post(this.BASE_URL+'user/save-assesment',{ "user_id" : user_id,"assessment_id":assessment_id,"course_id":course_id, "request_status":request_status, },this.httpOptions2);
   }
   // Contact to Administrator for assessment
  contactAdministratorForAss(user_id:number,assessment_id:any, request_status:any): Observable<any>{
    return this.http.post(this.BASE_URL+'contact/assessment/admin',{ "user_id" : user_id,"assessment_id":assessment_id, "request_status":request_status, },this.httpOptions2);
   }
  
   ViewCoursesAcceptReject(user_id:number,course_id:any,assessment_id:any, request_status:any,reject_reason:any ): Observable<any>{
    return this.http.post(this.BASE_URL+'user/save-assesment',{ "user_id" : user_id,"assessment_id":assessment_id,"course_id":course_id, "request_status":request_status, "reject_reason":reject_reason},this.httpOptions2);
   }
   previousQuestion(user_id:any,course_id:any,assessment_id:any, question_id:any): Observable<any>{
    return this.http.post(this.BASE_URL+'assessment/previous/list',{ "user_id" : user_id,"course_id":course_id,"assessment_id":assessment_id, "question_id":question_id},this.httpOptions2);
   }
   checkCourseStatus(user_id:any,course_id:any): Observable<any>{
    return this.http.post(this.BASE_URL+'user/course/status',{ "user_id" : user_id,"course_id":course_id},this.httpOptions2);
   }
   checkAssmntStatus(user_id:any,assId:any,status:any): Observable<any>{
    return this.http.post(this.BASE_URL+'user/assessmnt/status',{ "user_id" : user_id,"assessment_id":assId, "status":status},this.httpOptions2);
   }
   contact_us(formData:any): Observable<any>{
    return this.http.post(this.BASE_URL+'create/contact',formData);
   }
   getQueryList(user_id:any): Observable<any>{
    return this.http.post(this.BASE_URL+'show/contact',this.httpOptions2);
  }
  sideMenuDetail(module_id:any): Observable<any>{
    return this.http.post(this.BASE_URL+'user/module/detail',{ "module_id":module_id},this.httpOptions2);
   }
    assessmentsSubmit(user_id:number,assessment_id:any,question_num:any,question_id:any,response_text:any,response_id:any,total_time_spent:any,total_question:any,
      assessmentAttemt:any,assessment_type:any,matchData:any): Observable<any>{

     return this.http.post(this.BASE_URL+'assesment/result',{ 
      "user_id" : user_id,"assessment_id" : assessment_id,"question_num" : question_num,"question_id" : question_id,"response_text": response_text,
      "response_id" :response_id, "total_time_spent" : total_time_spent,"total_question" : total_question,"attempt_num":assessmentAttemt,
      "assessment_type":assessment_type,"matchData":matchData},
      this.httpOptions1);
    }

    assesmentFinalSubmit(postJson: any) {
      return this.http.post<any>(this.BASE_URL+'assesment/evaluation/result', postJson, this.httpOptions2)
        .pipe(map(data => {
          if (data) {
            return data;
          }
        }),
          catchError(this.handleError)
        );
    }
    assesmentSubmit(postJson: any) {
      return this.http.post<any>(this.BASE_URL+'assesment/evaluation1/result', postJson, this.httpOptions2)
        .pipe(map(data => {
          if (data) {
            return data;
          }
        }),
          catchError(this.handleError)
        );
    }
}
